import React, { useContext } from "react";
import { ControlpanelContext } from "../../../util/context";
import BillingDetails from "../../components/BillingDetails";
import FeatureDetails from "../../components/FeatureDetails";
import "./Confirmation.scss";

export default function Confirmation() {
    const { accountSetup, montlyBillingSetup,
        yearlyBillingSetup, payloadFeatures } = useContext(ControlpanelContext)

    return (
        <div>

            <div className="BillingDetailsContent">
                <div className="planHeader">
                    <span className="planbillingTitle">{accountSetup.plan_name}</span>
                   <div className="confirmation-container">
                   <span className="sequenceidconfirm">Sequence ID: {accountSetup.plan_order}</span>
                   <span className="separator">|</span>
                   <span className="sequenceidconfirm">Free trial period: {accountSetup.trail_period+" "}days </span>
                   </div>
                </div>

                <div className="BillingDetailsWrapper">
                    <div className="leftBilling-section">
                        <BillingDetails plans={{
                            mbill: montlyBillingSetup,
                            ybill: yearlyBillingSetup
                        }} />
                    </div>
                    <div className="rightBilling-section">
                        <FeatureDetails featureplans={payloadFeatures} />
                    </div>
                </div>
            </div>

        </div>
    );
}
